export default {"src":"/_next/static/media/devkrest-logo-full-white.6e0cc206.svg","height":46,"width":161,"blurWidth":0,"blurHeight":0};